/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CeaInfindCeasByCta model module.
 * @module model/CeaInfindCeasByCta
 * @version 2.8.0
 */
class CeaInfindCeasByCta {
    /**
     * Constructs a new <code>CeaInfindCeasByCta</code>.
     * @alias module:model/CeaInfindCeasByCta
     * @param columnIndex {Number} 
     * @param label {String} 
     * @param uri {String} 
     */
    constructor(columnIndex, label, uri) { 
        
        CeaInfindCeasByCta.initialize(this, columnIndex, label, uri);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, columnIndex, label, uri) { 
        obj['columnIndex'] = columnIndex;
        obj['label'] = label;
        obj['uri'] = uri;
    }

    /**
     * Constructs a <code>CeaInfindCeasByCta</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CeaInfindCeasByCta} obj Optional instance to populate.
     * @return {module:model/CeaInfindCeasByCta} The populated <code>CeaInfindCeasByCta</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CeaInfindCeasByCta();

            if (data.hasOwnProperty('columnIndex')) {
                obj['columnIndex'] = ApiClient.convertToType(data['columnIndex'], 'Number');
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('uri')) {
                obj['uri'] = ApiClient.convertToType(data['uri'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} columnIndex
 */
CeaInfindCeasByCta.prototype['columnIndex'] = undefined;

/**
 * @member {String} label
 */
CeaInfindCeasByCta.prototype['label'] = undefined;

/**
 * @member {String} uri
 */
CeaInfindCeasByCta.prototype['uri'] = undefined;






export default CeaInfindCeasByCta;

